import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { map, take } from 'rxjs';
import AppState from '../../app.state';
import { selectSelectedUserKind } from '../../features/auth/state-management/auth.selectors';
import { AppRoutes } from '../constants/routes.constants';

export const adminGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(selectSelectedUserKind).pipe(
    take(1),
    map((userKind) => {
      if (userKind === 'superAdmin' || (userKind as string) === 'admin') {
        return true;
      }
      router.navigate([`/${AppRoutes.LOGIN}`]);
      return false;
    })
  );
};

export const doormanGuard: CanActivateFn = () => {
  const store = inject(Store<AppState>);
  const router = inject(Router);

  return store.select(selectSelectedUserKind).pipe(
    take(1),
    map((userKind) => {
      if (userKind === 'doorman') {
        return true;
      }
      router.navigate([`/${AppRoutes.LOGIN}`]);
      return false;
    })
  );
};
